import React, { useContext, useState } from 'react';
import { Alert } from '@tportal/login/types';

type AlertProviderProps = { children: React.ReactNode };

const AlertContext = React.createContext<
  {alert: Alert | null; setAlert: React.Dispatch<React.SetStateAction<Alert | null>>} | undefined
  >(undefined);

function AlertProvider({ children }: AlertProviderProps) {
  const [alert, setAlert] = useState<Alert | null>(null);
  const value = { alert, setAlert };

  return (
    <AlertContext.Provider value={value}>
      {children}
    </AlertContext.Provider>
  );
}

const useAlert = () => {
  const context = useContext(AlertContext);
  if (context === undefined) {
    throw new Error('useAlert must be used within an AlertProvider');
  }

  return context;
};

export { AlertProvider, useAlert };
